import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { push } from "react-router-redux";
import { auth } from "../../firebase/firebase";
import {
  SIGNIN_USER,
  SIGNOUT_USER,
  SIGNUP_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from "constants/ActionTypes";
import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
  userSignUpSuccess,
} from "../../appRedux/actions/Auth";
import { hideAuthLoader } from "../actions/Auth";
import AuthApi from "./../../services/auth.service";
import { message } from "antd";

const createUserWithEmailPasswordRequest = async (email, password) =>
  await auth
    .createUserWithEmailAndPassword(email, password)
    .then((authUser) => authUser)
    .catch((error) => error);

const signOutRequest = async () =>
  await auth
    .signOut()
    .then((authUser) => authUser)
    .catch((error) => error);

function* createUserWithEmailPassword({ payload }) {
  const { email, password } = payload;
  try {
    const signUpUser = yield call(
      createUserWithEmailPasswordRequest,
      email,
      password
    );
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.user.uid);
      yield put(userSignUpSuccess(signUpUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithEmailPassword({ payload }) {
  try {
    const authApi = new AuthApi(null);
    const response = yield authApi.adminLogin(payload);
    if (response && response.code === 200) {
      yield put(userSignInSuccess(response.data));
      yield put(push("/database/view"));
    } else {
      yield put(hideAuthLoader());
      message.error(response.message);
    }
  } catch (error) {
    message.error("Invalid Password or Email");
    yield put(hideAuthLoader());
  }
}

function* signOut() {
  try {
    const signOutUser = yield call(signOutRequest);
    if (signOutUser === undefined) {
      localStorage.removeItem("user_id");
      yield put(userSignOutSuccess(signOutUser));
    } else {
      yield put(showAuthMessage(signOutUser.message));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* userForgotPassword({ payload }) {
  try {
    const authApi = new AuthApi(null);
    const response = yield authApi.forgotPassword(payload.email);
    if (response && response.code === 200) {
      message.success(response.message);
      payload.form.resetFields();
    } else {
      // yield put(hideForgotPassLoader());
      message.error(response.message);
    }
  } catch (error) {
    // yield put(hideForgotPassLoader());
    message.error("Invalid Email");
    payload.form.resetFields();
  }
}

function* userResetPassword({ payload }) {
  try {
    const authApi = new AuthApi(null);
    const response = yield authApi.resetPassword(payload);
    if (response && response.code === 200) {
      message.success(response.message);
      yield put(push("/login"));
    } else {
      message.error(response.message);
    }
  } catch (error) {
    message.error("Invalid password");
  }
}

export function* createUserAccount() {
  yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export function* forgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, userForgotPassword);
}

export function* resetPassword() {
  yield takeEvery(RESET_PASSWORD, userResetPassword);
}

export default function* rootSaga() {
  yield all([
    fork(signInUser),
    fork(createUserAccount),
    fork(signOutUser),
    fork(forgotPassword),
    fork(resetPassword),
  ]);
}
